import * as actionTypes from "./actionTypes";

export const loadHomeRecommededRes = (data) => {
  return {
    type: actionTypes.HOME_RECOMMENDED_RESTAURANT,
    data,
  };
};
export const loadHomeRecommededResSuccess = (data) => {
  return {
    type: actionTypes.HOME_RECOMMENDED_RESTAURANT_SUCCESS,
    data,
  };
};
export const loadRestaurant = (data, pagination = false) => {
  return {
    type: actionTypes.LOAD_RESTAURANT,
    data,
    pagination,
  };
};

export const loadRestaurantSuccess = (data, pagination, params = false) => {
  return {
    type: actionTypes.LOAD_RESTAURANT_SUCCESS,
    data,
    pagination,
    params,
  };
};

export const loadRestaurant_loaded = (data, pagination = false) => {
  return {
    type: actionTypes.LOAD_RESTAURANT_LOADED,
    data,
    pagination,
  };
};

export const loadRestaurantSuccess_loaded = () => {
  return {
    type: actionTypes.LOAD_RESTAURANT_LOADED_SUCCESS,
  };
};

export const loadRestaurantFail = () => {
  return {
    type: actionTypes.LOAD_RESTAURANT_FAIL,
  };
};

export const loadDeliveryAnnouncement = (data) => {
  return {
    type: actionTypes.LOAD_DELIVERY_ANNOUNCEMENT,
    data,
  };
};

export const loadDeliveryAnnouncementSuccess = (data) => {
  return {
    type: actionTypes.LOAD_DELIVERY_ANNOUNCEMENT_SUCCESS,
    data,
  };
};

export const loadDeliveryAnnouncementFail = () => {
  return {
    type: actionTypes.LOAD_DELIVERY_ANNOUNCEMENT_FAIL,
  };
};

export const getRestaurantDetail = (id) => {
  return {
    type: actionTypes.GET_RESTAURANT_DETAIL,
    id,
  };
};

export const getRestaurantDetailSuccess = (data) => {
  return {
    type: actionTypes.GET_RESTAURANT_DETAIL_SUCCESS,
    data,
  };
};

export const getRestaurantDetailFail = () => {
  return {
    type: actionTypes.GET_RESTAURANT_DETAIL_FAIL,
  };
};

export const loadRestaurantAlbum = (
  restID,
  album,
  offset = null,
  limit = null
) => {
  return {
    type: actionTypes.LOAD_RESTAURANT_ALBUM,
    restID,
    album,
    offset,
    limit,
  };
};

export const loadRestaurantAlbumSuccess = (data) => {
  return {
    type: actionTypes.LOAD_RESTAURANT_ALBUM_SUCCESS,
    data,
  };
};

export const loadRestaurantAlbumFail = () => {
  return {
    type: actionTypes.LOAD_RESTAURANT_ALBUM_FAIL,
  };
};

export const checkRestaurantCoverage = (data) => {
  return {
    type: actionTypes.CHECK_RESTAURANT_COVERAGE,
    data,
  };
};

export const checkRestaurantCoverageSuccess = (data) => {
  return {
    type: actionTypes.CHECK_RESTAURANT_COVERAGE_SUCCESS,
    data,
  };
};

export const checkRestaurantCoverageFail = () => {
  return {
    type: actionTypes.CHECK_RESTAURANT_COVERAGE_FAIL,
  };
};

// GENERAL
// Get Shop LOLOL ID
export const getShopLololLID = (data) => {
  return {
    type: actionTypes.GET_SHOP_LOLOL_ID,
    data,
  };
};
export const getShopLololLIDSuccess = (data) => {
  return {
    type: actionTypes.GET_SHOP_LOLOL_ID_SUCCESS,
    data,
  };
};
export const getShopLololLIDFail = () => {
  return {
    type: actionTypes.GET_SHOP_LOLOL_ID_FAIL,
  };
};
// END Get Shop LOLOL ID

export const getStateList = (state = null, district = null) => {
  return {
    type: actionTypes.GET_STATE_LIST,
    state,
    district,
  };
};

export const getStateListSuccess = (data) => {
  return {
    type: actionTypes.GET_STATE_LIST_SUCCESS,
    data,
  };
};

export const getStateListFail = () => {
  return {
    type: actionTypes.GET_STATE_LIST_FAIL,
  };
};

export const getRestaurantFilterList = (data) => {
  return {
    type: actionTypes.GET_RESTAURANT_FILTER_LIST,
    data,
  };
};

export const getRestaurantFilterListSuccess = (filter, data) => {
  return {
    type: actionTypes.GET_RESTAURANT_FILTER_LIST_SUCCESS,
    filter,
    data,
  };
};

export const getRestaurantFilterListFail = () => {
  return {
    type: actionTypes.GET_RESTAURANT_FILTER_LIST_FAIL,
  };
};

// Check Payment Code
export const checkPaymentCode = (data) => {
  return {
    type: actionTypes.CHECK_PAYMENT_CODE,
    data,
  };
};

export const checkPaymentCodeSuccess = (code1, code2) => {
  return {
    type: actionTypes.CHECK_PAYMENT_CODE_SUCCESS,
    code1,
    code2,
  };
};

export const checkPaymentCodeFail = () => {
  return {
    type: actionTypes.CHECK_PAYMENT_CODE_FAIL,
  };
};

// View Count
export const updateViewCount = (data) => {
  return {
    type: actionTypes.UPDATE_VIEW_COUNT,
    data,
  };
};

export const updateViewCountSuccess = () => {
  return {
    type: actionTypes.UPDATE_VIEW_COUNT_SUCCESS,
  };
};

export const updateViewCountFail = () => {
  return {
    type: actionTypes.UPDATE_VIEW_COUNT_FAIL,
  };
};
